export const SUCCESS = '0000';
export const ALREADY_REGISTERED = '2006';
